import React from 'react';
import { Link } from 'react-router-dom';

export default function RiderSubMenu({ open, onClose }) {
  React.useEffect(() => {
    // lock scroll
    if (open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [open]);

  React.useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] md:hidden" role="dialog" aria-modal="true">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-[1px]" onClick={onClose} />

      {/* Drawer */}
      <div
        className="
          absolute right-0 top-0 h-full w-[82vw] max-w-[320px]
          bg-white shadow-2xl
          pt-[max(env(safe-area-inset-top),0.75rem)] pb-[max(env(safe-area-inset-bottom),0.75rem)]
          flex flex-col
        "
      >
        <div className="px-4 pb-3 flex items-center justify-between">
          <span className="font-semibold">Rider Menu</span>
          <button className="p-2 rounded hover:bg-gray-100" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <nav className="px-2 flex-1 overflow-auto">
          <ul className="space-y-1">
            <li>
              <Link className="block px-3 py-2 rounded hover:bg-brand-50" to="/rider/job-claim" onClick={onClose}>
                🚚 Claim Jobs
              </Link>
            </li>
            <li>
              <Link className="block px-3 py-2 rounded hover:bg-brand-50" to="/rider/my-jobs" onClick={onClose}>
                📋 My Jobs
              </Link>
            </li>
            <li>
              <Link className="block px-3 py-2 rounded hover:bg-brand-50" to="/rider/wallet" onClick={onClose}>
                💰 Wallet
              </Link>
            </li>
            <li>
              <Link className="block px-3 py-2 rounded hover:bg-brand-50" to="/rider/analytics" onClick={onClose}>
                📊 Analytics
              </Link>
            </li>
            <li>
              <Link className="block px-3 py-2 rounded hover:bg-brand-50" to="/" onClick={onClose}>
                🏠 Back to Home
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
